class Logger {
    constructor(options) {
        var _ = this;

        _.debug = options.debug || false;
        _.prefix = options.prefix || '';
        _.logger = options.logger;
    }

    log() {
        var _ = this,
            args = arguments;

        if (_.debug) {
            Array.prototype.unshift.call(args, _.prefixxed());
            _.logger.log.apply(_.logger, args);
        }
    }

    error() {
        var _ = this,
            args = arguments;

        if (_.debug) {
            Array.prototype.unshift.call(args, _.prefixxed());
            _.logger.error.apply(_.logger, args);
        }
    }

    warn() {
        var _ = this,
            args = arguments;

        if (_.debug) {
            Array.prototype.unshift.call(args, _.prefixxed());
            _.logger.warn.apply(_.logger, args);
        }
    }

    prefixxed() {
        var _ = this;
        return typeof _.prefix === 'function' ? _.prefix() : _.prefix;
    }
}

export default Logger;
